import React from 'react';

export const ReportsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="
http://www.w3.org/2000/svg"
  >
    <path
      d="M9 19H15C15.2833 19 15.5208 18.9042 15.7125 18.7125C15.9042 18.5208 16 18.2833 16 18C16 17.7167 15.9042 17.4792 15.7125 17.2875C15.5208 17.0958 15.2833 17 15 17H9C8.71667 17 8.47917 17.0958 8.2875 17.2875C8.09583 17.4792 8 17.7167 8 18C8 18.2833 8.09583 18.5208 8.2875 18.7125C8.47917 18.9042 8.71667 19 9 19ZM9 16H15C15.2833 16 15.5208 15.9042 15.7125 15.7125C15.9042 15.5208 16 15.2833 16 15C16 14.7167 15.9042 14.4792 15.7125 14.2875C15.5208 14.0958 15.2833 14 15 14H9C8.71667 14 8.47917 14.0958 8.2875 14.2875C8.09583 14.4792 8 14.7167 8 15C8 15.2833 8.09583 15.5208 8.2875 15.7125C8.47917 15.9042 8.71667 16 9 16ZM18 22H6C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22ZM6 20H18V4H6V20Z"
      fill="#444D55"
    />
    <path
      d="M11.113 9.838L14.663 6.288C14.863 6.088 15.0963 5.99217 15.363 6.0005C15.6297 6.00883 15.863 6.113 16.063 6.313C16.2463 6.513 16.3422 6.74633 16.3505 7.013C16.3588 7.27967 16.263 7.513 16.063 7.713L11.813 11.963C11.613 12.163 11.3797 12.263 11.113 12.263C10.8463 12.263 10.613 12.163 10.413 11.963L8.288 9.813C8.10467 9.62967 8.00883 9.4005 8.0005 9.1255C7.99217 8.8505 8.088 8.613 8.288 8.413C8.47133 8.22967 8.70467 8.138 8.988 8.138C9.27133 8.138 9.50467 8.22967 9.688 8.413L11.113 9.838Z"
      fill="#444D55"
    />
  </svg>
);
